// export const studentMarksData = {
//   // B.Com Students Data
//   "B.Com(Yearly)":{
//     "2021-2022": [
//     {
//       rollNumber: "22046877",
//       name: "NAVOT SINGH",
//       enrollmentNo: "249634032870",
//       fatherName: "RESHAM SINGH",
//       motherName: "RANIT KOUR",
//       college: "AHILYABAI HOLKAR COLLEGE OF SCIENCE & TECHNOLOGY ASLEMPUR (MORADABAD)",
//       session: "2021-2022",
      
//       // First Year Marks
//       firstYear: {
//         year: "FIRST YEAR",
//         examYear: "2020",
//         rollNo: "8014100282",
//         subjects: [
//           { name: "BUSINESS COMMUNICATION", group: "A", maxMarks: 100, theory: 72, practical: null, total: null },
//           { name: "BUSINESS STATISTICS", group: "A", maxMarks: 100, theory: 69, practical: 64, total: 133 },
//           { name: "FINANCIAL ACCOUNTING", group: "B", maxMarks: 100, theory: 54, practical: null, total: null },
//           { name: "BUSINESS REGULATORY FRAMEWORK", group: "B", maxMarks: 100, theory: 63, practical: 9, total: 72 },
//           { name: "BUSINESS ECONOMICS", group: "C", maxMarks: 100, theory: 78, practical: null, total: null },
//           { name: "BUSINESS ENVIRONMENT", group: "C", maxMarks: 100, theory: 59, practical: 16, total: 75 }
//         ],
//         totalMarks: 395,
//         maxTotal: 600,
//         result: "PASS"
//       },
      
//       // Second Year Marks
//       secondYear: {
//         year: "SECOND YEAR",
//         examYear: "2021",
//         rollNo: "8014100282",
//         subjects: [
//           { name: "COMPANY LAW", group: "A", maxMarks: 100, theory: 69, practical: null, total: null },
//           { name: "COST ACCOUNTING", group: "A", maxMarks: 100, theory: 78, practical: 29, total: 107 },
//           { name: "PRINCIPLES OF BUSINESS MANAGEMENT", group: "B", maxMarks: 100, theory: 63, practical: null, total: null },
//           { name: "INCOME TAX", group: "B", maxMarks: 100, theory: 77, practical: 29, total: 106 },
//           { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 68, practical: null, total: null },
//           { name: "INDUSTRIAL LAW", group: "C", maxMarks: 100, theory: 66, practical: 32, total: 98 }
//         ],
//         totalMarks: 499,
//         maxTotal: 700,
//         result: "PASS"
//       },
      
//       // Third Year Marks
//       thirdYear: {
//         year: "THIRD YEAR",
//         examYear: "2022",
//         rollNo: "8014100282",
//         subjects: [
//           { name: "CORPORATE ACCOUNTING", group: "A", maxMarks: 100, theory: 74, practical: null, total: null },
//           { name: "AUDITING", group: "A", maxMarks: 100, theory: 68, practical: 68, total: 136 },
//           { name: "MONEY AND FINANCIAL SYSTEM", group: "B", maxMarks: 100, theory: 70, practical: null, total: null },
//           { name: "INFORMATION TECHNOLOGY & ITS IMPLICATION IN BUSINESS", group: "B", maxMarks: 100, theory: 65, practical: 65, total: 130 },
//           { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 80, practical: null, total: null },
//           { name: "MANAGEMENT ACCOUNTING", group: "C", maxMarks: 100, theory: 70, practical: 70, total: 140 },
//           { name: "VIVA-VOCE", group: "C", maxMarks: 100, theory: null, practical: 42, total: 42 }
//         ],
//         totalMarks: 518,
//         maxTotal: 700,
//         result: "PASS"
//       },
      
//       // Final Result
//       finalResult: {
//         grandTotal: 1412,
//         maxGrandTotal: 2000,
//         result: "PASS",
//         division: "FIRST"
//       },
      
//       // Qualifying Subjects
//       qualifyingSubjects: [
//         { name: "ENVIRONMENTAL SCIENCE", marks: 50 },
//         { name: "SPORTS & PHYSICAL EDUCATION", marks: 62 }
//       ],
      
//       // Status
//       status: {
//         firstYear: "CLEARED",
//         secondYear: "CLEARED", 
//         thirdYear: "CLEARED"
//       }
//     },
//   ],
//   "2023-2024":[
//  // Second Student - SANAMDEEP SINGH with good marks
//     {
//       rollNumber: "20245280",
//       name: "SANAMDEEP SINGH",
//       enrollmentNo: "449664034855",
//       fatherName: "KAMALEET SINGH",
//       motherName: "BALIT KAUR",
//       college: "AHILYABAI HOLKAR COLLEGE OF SCIENCE & TECHNOLOGY ASLEMPUR (MORADABAD)",
//       session: "2023-2024",
      
//       // First Year Marks - Good Marks
//       firstYear: {
//         year: "FIRST YEAR",
//         examYear: "2022",
//         rollNo: "2024100278",
//         subjects: [
//           { name: "BUSINESS COMMUNICATION", group: "A", maxMarks: 100, theory: 85, practical: null, total: null },
//           { name: "BUSINESS STATISTICS", group: "A", maxMarks: 100, theory: 82, practical: 75, total: 157 },
//           { name: "FINANCIAL ACCOUNTING", group: "B", maxMarks: 100, theory: 78, practical: null, total: null },
//           { name: "BUSINESS REGULATORY FRAMEWORK", group: "B", maxMarks: 100, theory: 88, practical: 9, total: 97 },
//           { name: "BUSINESS ECONOMICS", group: "C", maxMarks: 100, theory: 92, practical: null, total: null },
//           { name: "BUSINESS ENVIRONMENT", group: "C", maxMarks: 100, theory: 84, practical: 16, total: 100 }
//         ],
//         totalMarks: 519,
//         maxTotal: 600,
//         result: "PASS"
//       },
      
//       // Second Year Marks - Good Marks
//       secondYear: {
//         year: "SECOND YEAR",
//         examYear: "2023",
//         rollNo: "2024100278",
//         subjects: [
//           { name: "COMPANY LAW", group: "A", maxMarks: 100, theory: 89, practical: null, total: null },
//           { name: "COST ACCOUNTING", group: "A", maxMarks: 100, theory: 91, practical: 35, total: 126 },
//           { name: "PRINCIPLES OF BUSINESS MANAGEMENT", group: "B", maxMarks: 100, theory: 87, practical: null, total: null },
//           { name: "INCOME TAX", group: "B", maxMarks: 100, theory: 85, practical: 35, total: 120 },
//           { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 88, practical: null, total: null },
//           { name: "INDUSTRIAL LAW", group: "C", maxMarks: 100, theory: 90, practical: 38, total: 128 }
//         ],
//         totalMarks: 597,
//         maxTotal: 700,
//         result: "PASS"
//       },
      
//       // Third Year Marks - Good Marks
//       thirdYear: {
//         year: "THIRD YEAR",
//         examYear: "2024",
//         rollNo: "2024100278",
//         subjects: [
//           { name: "CORPORATE ACCOUNTING", group: "A", maxMarks: 100, theory: 89, practical: null, total: null },
//           { name: "AUDITING", group: "A", maxMarks: 100, theory: 85, practical: 85, total: 170 },
//           { name: "MONEY AND FINANCIAL SYSTEM", group: "B", maxMarks: 100, theory: 88, practical: null, total: null },
//           { name: "INFORMATION TECHNOLOGY & ITS IMPLICATION IN BUSINESS", group: "B", maxMarks: 100, theory: 92, practical: 92, total: 184 },
//           { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 94, practical: null, total: null },
//           { name: "MANAGEMENT ACCOUNTING", group: "C", maxMarks: 100, theory: 90, practical: 90, total: 180 },
//           { name: "VIVA-VOCE", group: "C", maxMarks: 100, theory: null, practical: 48, total: 48 }
//         ],
//         totalMarks: 665,
//         maxTotal: 700,
//         result: "PASS"
//       },
      
//       // Final Result - Excellent Performance
//       finalResult: {
//         grandTotal: 1781,
//         maxGrandTotal: 2000,
//         result: "PASS",
//         division: "FIRST"
//       },
      
//       // Qualifying Subjects
//       qualifyingSubjects: [
//         { name: "ENVIRONMENTAL SCIENCE", marks: 68 },
//         { name: "SPORTS & PHYSICAL EDUCATION", marks: 75 }
//       ],
      
//       // Status
//       status: {
//         firstYear: "CLEARED",
//         secondYear: "CLEARED", 
//         thirdYear: "CLEARED"
//       }
//     },
//   ]
//   },
// };

// export const data = {
//   "B.Com(Yearly)": {
//     "2021-2022": [
//       { 
//         rollNumber: "22046877", 
//         name: "NAVOT SINGH",
//         session: "2021-2022",
//         // marksData: studentMarksData["B.Com(Yearly)"]["2020-2021"][0]
//       }
//     ],
//     "2023-2024": [
//       { 
//         rollNumber: "20245280", 
//         name: "SANAMDEEP SINGH",
//         session: "2023-2024",
//         // marksData: studentMarksData["B.Com(Yearly)"]["2020-2021"][0]
//       }
//     ],
//   },
 
// };
// export const resultTypeMap = {
//     0: '--Select--',
//     1: 'Main Result',
//     2: 'Re-Evaluation Result',
//     3: 'Improvement Result',
//     4: 'Supplementary/Back Result',
//     5: 'Single Subject Result',
//     6: 'Left Out (Practical)',
//     7: 'Special Permission'
// };

// export const sessionMap = {
//     25: '2024-2025',
//     24: '2023-2024',
//     23: '2022-2023',
//     22: '2021-2022',
//     21: '2020-2021',
//     20: '2019-2020',
//     19: '2018-2019',
//     18: '2017-2018',
//     17: '2016-2017',
//     16: '2015-2016',
//     15: '2014-2015',
//     14: '2013-2014',
//     13: '2012-2013',
//     12: '2011-2012',
//     11: '2010-2011',
//     10: '2009-2010',
//     9: '2008-2009',
//     8: '2007-2008',
//     7: '2006-2007',
//     6: '2005-2006'
// };

// export const degreeTypeMap = {
//     1: 'SEMESTER',
//     2: 'ANNUAL'
// };

// export const courseMap = {
//     0: '--Select Course--',
//     1: 'PG Diploma',
//     3: 'Ph.D',
//     5: 'Post Graduate (PG)',
//     7: 'UG Diploma',
//     8: 'Under Graduate (UG)',
//     15: 'Diploma (Paramedical/Nursing)'
// };

// export const degreeMap = {
//     0: '--Select Degree--',
//     3: 'B.A(Yearly)',
//     4: 'B.Com(Yearly)',
//     5: 'B.Sc(Yearly)',
//     6: 'B.B.A',
//     7: 'B.C.A.',
//     8: 'B.Pharma',
//     9: 'B.Tech',
//     10: 'BHM & CT',
//     11: 'B.Com Finance',
//     12: 'B.Com Financial Service',
//     13: 'B.Sc. (Hons) Agriculture',
//     14: 'B.Sc. AGRICULTURE',
//     15: 'LLB',
//     16: 'B.A L.L.B (5 Years)',
//     17: 'B.Lib',
//     18: 'B.Pharma (Old)',
//     19: 'Bachelor of Management Studies',
//     20: 'B.Sc. Home Science (Semester)',
//     49: 'M.B.B.S',
//     50: 'B.D.S',
//     89: 'B.A.M.S',
//     90: 'B.Com. (Honors)',
//     91: 'B.Com. (Computer)',
//     92: 'B.Sc (Computer Science)',
//     93: 'B.Sc (Microbiology)',
//     94: 'B.Sc (Honors)',
//     95: 'B.Sc. (Biotechnology)',
//     96: 'B.Sc. (Home Science)',
//     97: 'BUMS',
//     98: 'B.Sc. NURSING',
//     99: 'B.Sc Post Basic (Nursing)',
//     100: 'Bachelor of Operation Theatre Technology',
//     101: 'B.ED (Campus)',
//     102: 'B.ED (Yearly)',
//     103: 'B.SC PHYSIOTHERAPY',
//     104: 'B.Sc. In Medical Laboratory Techniques',
//     105: 'B.Sc. In Radiological Imaging Techniques',
//     106: 'Bachelor of Optometry',
//     107: 'B.EL.ED',
//     108: 'B.Sc. Agriculture (Special Permission)'
// };

export const studentMarksData = {
  // B.Com Students Data
  "B.Com(Yearly)":{
    "2021-2022": [
    {
      rollNumber: "22046877",
      name: "NAVOT SINGH",
      enrollmentNo: "249634032870",
      fatherName: "RESHAM SINGH",
      motherName: "RANJIT KOUR",
      college: "AHILYABAI HOLKAR COLLEGE OF SCIENCE & TECHNOLOGY ASLEMPUR (MORADABAD)",
      session: "2021-2022",
      
      // First Year Marks
      firstYear: {
        year: "FIRST YEAR",
        examYear: "2020",
        rollNo: "8014100282",
        subjects: [
          { name: "BUSINESS COMMUNICATION", group: "A", maxMarks: 100, theory: 72, practical: null, total: null },
          { name: "BUSINESS STATISTICS", group: "A", maxMarks: 100, theory: 69, practical: 64, total: 133 },
          { name: "FINANCIAL ACCOUNTING", group: "B", maxMarks: 100, theory: 54, practical: null, total: null },
          { name: "BUSINESS REGULATORY FRAMEWORK", group: "B", maxMarks: 100, theory: 63, practical: 9, total: 72 },
          { name: "BUSINESS ECONOMICS", group: "C", maxMarks: 100, theory: 78, practical: null, total: null },
          { name: "BUSINESS ENVIRONMENT", group: "C", maxMarks: 100, theory: 59, practical: 16, total: 75 }
        ],
        totalMarks: 395,
        maxTotal: 600,
        result: "PASS"
      },
      
      // Second Year Marks
      secondYear: {
        year: "SECOND YEAR",
        examYear: "2021",
        rollNo: "8014100282",
        subjects: [
          { name: "COMPANY LAW", group: "A", maxMarks: 100, theory: 69, practical: null, total: null },
          { name: "COST ACCOUNTING", group: "A", maxMarks: 100, theory: 78, practical: 29, total: 107 },
          { name: "PRINCIPLES OF BUSINESS MANAGEMENT", group: "B", maxMarks: 100, theory: 63, practical: null, total: null },
          { name: "INCOME TAX", group: "B", maxMarks: 100, theory: 77, practical: 29, total: 106 },
          { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 68, practical: null, total: null },
          { name: "INDUSTRIAL LAW", group: "C", maxMarks: 100, theory: 66, practical: 32, total: 98 }
        ],
        totalMarks: 499,
        maxTotal: 700,
        result: "PASS"
      },
      
      // Third Year Marks
      thirdYear: {
        year: "THIRD YEAR",
        examYear: "2022",
        rollNo: "8014100282",
        subjects: [
          { name: "CORPORATE ACCOUNTING", group: "A", maxMarks: 100, theory: 74, practical: null, total: null },
          { name: "AUDITING", group: "A", maxMarks: 100, theory: 68, practical: 68, total: 136 },
          { name: "MONEY AND FINANCIAL SYSTEM", group: "B", maxMarks: 100, theory: 70, practical: null, total: null },
          { name: "INFORMATION TECHNOLOGY & ITS IMPLICATION IN BUSINESS", group: "B", maxMarks: 100, theory: 65, practical: 65, total: 130 },
          { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 80, practical: null, total: null },
          { name: "MANAGEMENT ACCOUNTING", group: "C", maxMarks: 100, theory: 70, practical: 70, total: 140 },
          { name: "VIVA-VOCE", group: "C", maxMarks: 100, theory: null, practical: 42, total: 42 }
        ],
        totalMarks: 518,
        maxTotal: 700,
        result: "PASS"
      },
      
      // Final Result
      finalResult: {
        grandTotal: 1412,
        maxGrandTotal: 2000,
        result: "PASS",
        division: "FIRST"
      },
      
      // Qualifying Subjects
      qualifyingSubjects: [
        { name: "ENVIRONMENTAL SCIENCE", marks: 50 },
        { name: "SPORTS & PHYSICAL EDUCATION", marks: 62 }
      ],
      
      // Status
      status: {
        firstYear: "CLEARED",
        secondYear: "CLEARED", 
        thirdYear: "CLEARED"
      }
    },
  ],
  "2023-2024":[
    // First Student - SANAMDEEP SINGH with good marks
    {
      rollNumber: "20245280",
      name: "SANAMDEEP SINGH",
      enrollmentNo: "449664034855",
      fatherName: "KAMALEET SINGH",
      motherName: "BALIT KAUR",
      college: "AHILYABAI HOLKAR COLLEGE OF SCIENCE & TECHNOLOGY ASLEMPUR (MORADABAD)",
      session: "2023-2024",
      
      // First Year Marks - Good Marks
      firstYear: {
        year: "FIRST YEAR",
        examYear: "2022",
        rollNo: "2024100278",
        subjects: [
          { name: "BUSINESS COMMUNICATION", group: "A", maxMarks: 100, theory: 85, practical: null, total: null },
          { name: "BUSINESS STATISTICS", group: "A", maxMarks: 100, theory: 82, practical: 75, total: 157 },
          { name: "FINANCIAL ACCOUNTING", group: "B", maxMarks: 100, theory: 78, practical: null, total: null },
          { name: "BUSINESS REGULATORY FRAMEWORK", group: "B", maxMarks: 100, theory: 88, practical: 9, total: 97 },
          { name: "BUSINESS ECONOMICS", group: "C", maxMarks: 100, theory: 92, practical: null, total: null },
          { name: "BUSINESS ENVIRONMENT", group: "C", maxMarks: 100, theory: 84, practical: 16, total: 100 }
        ],
        totalMarks: 519,
        maxTotal: 600,
        result: "PASS"
      },
      
      // Second Year Marks - Good Marks
      secondYear: {
        year: "SECOND YEAR",
        examYear: "2023",
        rollNo: "2024100278",
        subjects: [
          { name: "COMPANY LAW", group: "A", maxMarks: 100, theory: 89, practical: null, total: null },
          { name: "COST ACCOUNTING", group: "A", maxMarks: 100, theory: 91, practical: 35, total: 126 },
          { name: "PRINCIPLES OF BUSINESS MANAGEMENT", group: "B", maxMarks: 100, theory: 87, practical: null, total: null },
          { name: "INCOME TAX", group: "B", maxMarks: 100, theory: 85, practical: 35, total: 120 },
          { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 88, practical: null, total: null },
          { name: "INDUSTRIAL LAW", group: "C", maxMarks: 100, theory: 90, practical: 38, total: 128 }
        ],
        totalMarks: 597,
        maxTotal: 700,
        result: "PASS"
      },
      
      // Third Year Marks - Good Marks
      thirdYear: {
        year: "THIRD YEAR",
        examYear: "2024",
        rollNo: "2024100278",
        subjects: [
          { name: "CORPORATE ACCOUNTING", group: "A", maxMarks: 100, theory: 89, practical: null, total: null },
          { name: "AUDITING", group: "A", maxMarks: 100, theory: 85, practical: 85, total: 170 },
          { name: "MONEY AND FINANCIAL SYSTEM", group: "B", maxMarks: 100, theory: 88, practical: null, total: null },
          { name: "INFORMATION TECHNOLOGY & ITS IMPLICATION IN BUSINESS", group: "B", maxMarks: 100, theory: 92, practical: 92, total: 184 },
          { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 94, practical: null, total: null },
          { name: "MANAGEMENT ACCOUNTING", group: "C", maxMarks: 100, theory: 90, practical: 90, total: 180 },
          { name: "VIVA-VOCE", group: "C", maxMarks: 100, theory: null, practical: 48, total: 48 }
        ],
        totalMarks: 665,
        maxTotal: 700,
        result: "PASS"
      },
      
      // Final Result - Excellent Performance
      finalResult: {
        grandTotal: 1781,
        maxGrandTotal: 2000,
        result: "PASS",
        division: "FIRST"
      },
      
      // Qualifying Subjects
      qualifyingSubjects: [
        { name: "ENVIRONMENTAL SCIENCE", marks: 68 },
        { name: "SPORTS & PHYSICAL EDUCATION", marks: 75 }
      ],
      
      // Status
      status: {
        firstYear: "CLEARED",
        secondYear: "CLEARED", 
        thirdYear: "CLEARED"
      }
    },
    
    // NEW STUDENT - HARMAN SINGH with good marks
    {
      rollNumber: "20245567",
      name: "HARMAN SINGH",
      enrollmentNo: "449664034856",
      fatherName: "AVTAR SINGH",
      motherName: "PARAMJEET KAUR",
      college: "AHILYABAI HOLKAR COLLEGE OF SCIENCE & TECHNOLOGY ASLEMPUR (MORADABAD)",
      session: "2023-2024",
      
      // First Year Marks - Good Marks
      firstYear: {
        year: "FIRST YEAR",
        examYear: "2022",
        rollNo: "2024100279",
        subjects: [
          { name: "BUSINESS COMMUNICATION", group: "A", maxMarks: 100, theory: 87, practical: null, total: null },
          { name: "BUSINESS STATISTICS", group: "A", maxMarks: 100, theory: 70, practical: 14, total: 84 },
          { name: "FINANCIAL ACCOUNTING", group: "B", maxMarks: 100, theory: 82, practical: null, total: null },
          { name: "BUSINESS REGULATORY FRAMEWORK", group: "B", maxMarks: 100, theory: 86, practical: 8, total: 94 },
          { name: "BUSINESS ECONOMICS", group: "C", maxMarks: 100, theory: 90, practical: null, total: null },
          { name: "BUSINESS ENVIRONMENT", group: "C", maxMarks: 100, theory: 62, practical: 13, total: 75 }
        ],
        totalMarks: 512,
        maxTotal: 600,
        result: "PASS"
      },
      
      // Second Year Marks - Good Marks
      secondYear: {
        year: "SECOND YEAR",
        examYear: "2023",
        rollNo: "2024100279",
        subjects: [
          { name: "COMPANY LAW", group: "A", maxMarks: 100, theory: 88, practical: null, total: null },
          { name: "COST ACCOUNTING", group: "A", maxMarks: 130, theory: 90, practical: 36, total: 126 },
          { name: "PRINCIPLES OF BUSINESS MANAGEMENT", group: "B", maxMarks: 100, theory: 85, practical: null, total: null },
          { name: "INCOME TAX", group: "B", maxMarks: 130, theory: 87, practical: 34, total: 121 },
          { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 89, practical: null, total: null },
          { name: "INDUSTRIAL LAW", group: "C", maxMarks: 140, theory: 91, practical: 37, total: 128 }
        ],
        totalMarks: 637,
        maxTotal: 700,
        result: "PASS"
      },
      
      // Third Year Marks - Good Marks
      thirdYear: {
        year: "THIRD YEAR",
        examYear: "2024",
        rollNo: "2024100279",
        subjects: [
          { name: "CORPORATE ACCOUNTING", group: "A", maxMarks: 100, theory: 88, practical: null, total: null },
          { name: "AUDITING", group: "A", maxMarks: 100, theory: 67, practical: 12, total: 79 },
          { name: "MONEY AND FINANCIAL SYSTEM", group: "B", maxMarks: 100, theory: 87, practical: null, total: null },
          { name: "INFORMATION TECHNOLOGY & ITS IMPLICATION IN BUSINESS", group: "B", maxMarks: 100, theory: 61, practical: 16, total: 77 },
          { name: "FINANCIAL MANAGEMENT", group: "C", maxMarks: 100, theory: 83, practical: null, total: null },
          { name: "MANAGEMENT ACCOUNTING", group: "C", maxMarks: 100, theory: 50, practical: 18, total: 68 },
          { name: "VIVA-VOCE", group: "C", maxMarks: 100, theory: null, practical: 48, total: 48 }
        ],
        totalMarks: 530,
        maxTotal: 700,
        result: "PASS"
      },
      
      // Final Result - Excellent Performance
      finalResult: {
        grandTotal: 1788,
        maxGrandTotal: 2000,
        result: "PASS",
        division: "FIRST"
      },
      
      // Qualifying Subjects
      qualifyingSubjects: [
        { name: "ENVIRONMENTAL SCIENCE", marks: 72 },
        { name: "SPORTS & PHYSICAL EDUCATION", marks: 78 }
      ],
      
      // Status
      status: {
        firstYear: "CLEARED",
        secondYear: "CLEARED", 
        thirdYear: "CLEARED"
      }
    },
  ]
  },
};

export const data = {
  "B.Com(Yearly)": {
    "2021-2022": [
      { 
        rollNumber: "22046877", 
        name: "NAVOT SINGH",
        session: "2021-2022",
        // marksData: studentMarksData["B.Com(Yearly)"]["2020-2021"][0]
      }
    ],
    "2023-2024": [
      { 
        rollNumber: "20245280", 
        name: "SANAMDEEP SINGH",
        session: "2023-2024",
        // marksData: studentMarksData["B.Com(Yearly)"]["2020-2021"][0]
      },
      { 
        rollNumber: "20245567", 
        name: "HARMAN SINGH",
        session: "2023-2024",
        // marksData: studentMarksData["B.Com(Yearly)"]["2020-2021"][0]
      }
    ],
  },
 
};

export const resultTypeMap = {
    0: '--Select--',
    1: 'Main Result',
    2: 'Re-Evaluation Result',
    3: 'Improvement Result',
    4: 'Supplementary/Back Result',
    5: 'Single Subject Result',
    6: 'Left Out (Practical)',
    7: 'Special Permission'
};

export const sessionMap = {
    25: '2024-2025',
    24: '2023-2024',
    23: '2022-2023',
    22: '2021-2022',
    21: '2020-2021',
    20: '2019-2020',
    19: '2018-2019',
    18: '2017-2018',
    17: '2016-2017',
    16: '2015-2016',
    15: '2014-2015',
    14: '2013-2014',
    13: '2012-2013',
    12: '2011-2012',
    11: '2010-2011',
    10: '2009-2010',
    9: '2008-2009',
    8: '2007-2008',
    7: '2006-2007',
    6: '2005-2006'
};

export const degreeTypeMap = {
    1: 'SEMESTER',
    2: 'ANNUAL'
};

export const courseMap = {
    0: '--Select Course--',
    1: 'PG Diploma',
    3: 'Ph.D',
    5: 'Post Graduate (PG)',
    7: 'UG Diploma',
    8: 'Under Graduate (UG)',
    15: 'Diploma (Paramedical/Nursing)'
};

export const degreeMap = {
    0: '--Select Degree--',
    3: 'B.A(Yearly)',
    4: 'B.Com(Yearly)',
    5: 'B.Sc(Yearly)',
    6: 'B.B.A',
    7: 'B.C.A.',
    8: 'B.Pharma',
    9: 'B.Tech',
    10: 'BHM & CT',
    11: 'B.Com Finance',
    12: 'B.Com Financial Service',
    13: 'B.Sc. (Hons) Agriculture',
    14: 'B.Sc. AGRICULTURE',
    15: 'LLB',
    16: 'B.A L.L.B (5 Years)',
    17: 'B.Lib',
    18: 'B.Pharma (Old)',
    19: 'Bachelor of Management Studies',
    20: 'B.Sc. Home Science (Semester)',
    49: 'M.B.B.S',
    50: 'B.D.S',
    89: 'B.A.M.S',
    90: 'B.Com. (Honors)',
    91: 'B.Com. (Computer)',
    92: 'B.Sc (Computer Science)',
    93: 'B.Sc (Microbiology)',
    94: 'B.Sc (Honors)',
    95: 'B.Sc. (Biotechnology)',
    96: 'B.Sc. (Home Science)',
    97: 'BUMS',
    98: 'B.Sc. NURSING',
    99: 'B.Sc Post Basic (Nursing)',
    100: 'Bachelor of Operation Theatre Technology',
    101: 'B.ED (Campus)',
    102: 'B.ED (Yearly)',
    103: 'B.SC PHYSIOTHERAPY',
    104: 'B.Sc. In Medical Laboratory Techniques',
    105: 'B.Sc. In Radiological Imaging Techniques',
    106: 'Bachelor of Optometry',
    107: 'B.EL.ED',
    108: 'B.Sc. Agriculture (Special Permission)'
};